import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import api from "../../utils/api";

export default function EditVideo() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchVideo();
  }, []);

  const fetchVideo = async () => {
    try {
      const res = await api.get(`/client/video/${id}`);
      if (res?.data?.status) {
        const data = res.data.video;
        setTitle(data.title || "");
        setDescription(data.description || "");
      }
    } catch (err) {
      console.error("Load video error", err);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    try {
      await api.put(`/client/video/updateVideo/${id}`, {
        title,
        description,
      });

      alert("Updated successfully");
      navigate("/user/content");
    } catch (err) {
      console.error("Update failed", err);
      alert("Update failed");
    }
  };

  if (loading) return <p className="panel-loading">Loading...</p>;

  return (
    <div className="panel-container">
      <h2 className="section-title">
        {type === "2" ? "Edit Short" : "Edit Video"}
      </h2>

      <div className="form-card">
        <input
          type="text"
          className="form-input"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Video Title"
        />

        <textarea
          className="form-textarea"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Description"
        />

        <button className="primary-btn" onClick={handleUpdate}>
          Update
        </button>
      </div>
    </div>
  );
}
